import type { paths } from "../../__definitions__/twilio.changeengine.com-definitions";
import type { Workers } from "../../utils/service-url";
import type { ApiResponse } from "./client";
import { WorkerApiService } from "./worker";

type TwilioBuildMessageRequest =
  paths["/build-message"]["post"]["requestBody"]["content"]["application/json"];

export type TwilioMessage =
  paths["/build-message"]["post"]["responses"]["200"]["content"]["application/json"];

export class TwilioEngineSevice extends WorkerApiService {
  module = "twilio" as const satisfies Workers;

  async buildMessage(body: TwilioBuildMessageRequest): Promise<ApiResponse<TwilioMessage>> {
    return await this.post("build-message", { ...body, dynamic_condition_fields: {} });
  }
}
